import { put, select, takeLatest, all } from 'redux-saga/effects';
import { notify } from '@mrlannigan/reapop';
import { sagaError } from 'helpers/handleGenericSagaError';
import apiAuthCall from 'helpers/apiAuthCall';

import {
    actions,
    layerTwoSummaryFetched,
    layerTwoChannelSummaryFetched,
    layerTwoActivitiesFetched
} from './duck';

import {
    layerTwoSummaryEndpoint,
    layerTwoChannelSummaryEndpoint,
    layerTwoActivityEndpoint,
    layerTwoSEMSummaryEndpoint
} from './selectors';

export function* fetchLayerTwoSummary(api, action) {
    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'get',
                url: yield select(layerTwoSummaryEndpoint, action.payload)
            }
        );

        yield put(layerTwoSummaryFetched(result.data));
    } catch (err) {
        yield put(notify({
            id: action.payload.transactionId,
            ...sagaError(err)
        }));
    }
}

export function* fetchLayerTwoChannelSummary(api, action) {
    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'get',
                url: yield select(layerTwoChannelSummaryEndpoint, action.payload)
            }
        );

        yield put(layerTwoChannelSummaryFetched(result.data));
    } catch (err) {
        yield put(notify({
            id: action.payload.transactionId,
            ...sagaError(err)
        }));
    }
}

export function* fetchLayerTwoActivities(api, action) {
    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'get',
                url: yield select(layerTwoActivityEndpoint, action.payload)
            }
        );

        yield put(layerTwoActivitiesFetched(result.data));
    } catch (err) {
        yield put(notify({
            id: action.payload.transactionId,
            ...sagaError(err)
        }));
    }
}

export function* fetchLayerTwoSEMSummary(api, action) {
    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'get',
                url: yield select(layerTwoSEMSummaryEndpoint, action.payload)
            }
        );

        yield put(layerTwoChannelSummaryFetched(result.data));
    } catch (err) {
        yield put(notify({
            id: action.payload.transactionId,
            ...sagaError(err)
        }));
    }
}

export default function* layerTwoSaga({ api }) {
    yield all([
        takeLatest(actions.FETCH_SUMMARY, fetchLayerTwoSummary, api),
        takeLatest(actions.FETCH_ACTIVITIES, fetchLayerTwoActivities, api),
        takeLatest(actions.FETCH_CHANNEL_SUMMARY, fetchLayerTwoChannelSummary, api),
        takeLatest(actions.FETCH_SEM_SUMMARY, fetchLayerTwoSEMSummary, api)
    ]);
}



// WEBPACK FOOTER //
// ./src/services/layerTwo/saga.js